function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, i) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = i() : "function" == typeof define && define.amd ? define([], i) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueDragResize = i() : t.VueDragResize = i();
}(window, function () {
  return function (t) {
    function i(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    var e = {};
    return i.m = t, i.c = e, i.d = function (t, e, n) {
      i.o(t, e) || Object.defineProperty(t, e, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, i.r = function (t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, i) {
      return Object.prototype.hasOwnProperty.call(t, i);
    }, i.p = "", i(i.s = 44);
  }({
    0: function _(t, i, e) {
      var n = e(16);
      "string" == typeof n && (n = [[t.i, n, ""]]);
      var o = {};
      o.transform = void 0;
      e(5)(n, o);
      n.locals && (t.exports = n.locals);
    },
    1: function _(t, i, e) {
      "use strict";

      Object.defineProperty(i, "__esModule", {
        value: !0
      });
      var n = {
        y: {
          t: "top",
          m: "marginTop",
          b: "bottom"
        },
        x: {
          l: "left",
          m: "marginLeft",
          r: "right"
        }
      };
      i["default"] = {
        name: "vue-drag-resize",
        props: {
          parentScaleX: {
            type: Number,
            "default": 1
          },
          parentScaleY: {
            type: Number,
            "default": 1
          },
          isActive: {
            type: Boolean,
            "default": !1
          },
          preventActiveBehavior: {
            type: Boolean,
            "default": !1
          },
          isDraggable: {
            type: Boolean,
            "default": !0
          },
          isResizable: {
            type: Boolean,
            "default": !0
          },
          aspectRatio: {
            type: Boolean,
            "default": !1
          },
          parentLimitation: {
            type: Boolean,
            "default": !1
          },
          parentW: {
            type: Number,
            "default": 0,
            validator: function validator(t) {
              return t >= 0;
            }
          },
          parentH: {
            type: Number,
            "default": 0,
            validator: function validator(t) {
              return t >= 0;
            }
          },
          w: {
            type: Number,
            "default": 100,
            validator: function validator(t) {
              return t > 0;
            }
          },
          h: {
            type: Number,
            "default": 100,
            validator: function validator(t) {
              return t > 0;
            }
          },
          minw: {
            type: Number,
            "default": 50,
            validator: function validator(t) {
              return t > 0;
            }
          },
          minh: {
            type: Number,
            "default": 50,
            validator: function validator(t) {
              return t > 0;
            }
          },
          x: {
            type: Number,
            "default": 0,
            validator: function validator(t) {
              return "number" == typeof t;
            }
          },
          y: {
            type: Number,
            "default": 0,
            validator: function validator(t) {
              return "number" == typeof t;
            }
          },
          z: {
            type: [String, Number],
            "default": "auto",
            validator: function validator(t) {
              return "string" == typeof t ? "auto" === t : t >= 0;
            }
          },
          dragHandle: {
            type: String,
            "default": null
          },
          dragCancel: {
            type: String,
            "default": null
          },
          sticks: {
            type: Array,
            "default": function _default() {
              return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"];
            }
          },
          axis: {
            type: String,
            "default": "both",
            validator: function validator(t) {
              return -1 !== ["x", "y", "both", "none"].indexOf(t);
            }
          }
        },
        data: function data() {
          return {
            active: this.isActive,
            rawWidth: this.w,
            rawHeight: this.h,
            rawLeft: this.x,
            rawTop: this.y,
            rawRight: null,
            rawBottom: null,
            zIndex: this.z,
            aspectFactor: this.w / this.h,
            parentWidth: null,
            parentHeight: null,
            left: this.x,
            top: this.y,
            right: null,
            bottom: null,
            minWidth: this.minw,
            minHeight: this.minh
          };
        },
        created: function created() {
          this.stickDrag = !1, this.bodyDrag = !1, this.stickAxis = null, this.stickStartPos = {
            mouseX: 0,
            mouseY: 0,
            x: 0,
            y: 0,
            w: 0,
            h: 0
          }, this.limits = {
            minLeft: null,
            maxLeft: null,
            minRight: null,
            maxRight: null,
            minTop: null,
            maxTop: null,
            minBottom: null,
            maxBottom: null
          }, this.currentStick = [];
        },
        mounted: function mounted() {
          if (this.parentElement = this.$el.parentNode, this.parentWidth = this.parentW ? this.parentW : this.parentElement.clientWidth, this.parentHeight = this.parentH ? this.parentH : this.parentElement.clientHeight, this.rawRight = this.parentWidth - this.rawWidth - this.rawLeft, this.rawBottom = this.parentHeight - this.rawHeight - this.rawTop, document.documentElement.addEventListener("mousemove", this.move), document.documentElement.addEventListener("mouseup", this.up), document.documentElement.addEventListener("mouseleave", this.up), document.documentElement.addEventListener("mousedown", this.deselect), document.documentElement.addEventListener("touchmove", this.move, !0), document.documentElement.addEventListener("touchend touchcancel", this.up, !0), document.documentElement.addEventListener("touchstart", this.up, !0), this.dragHandle) {
            var t = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragHandle));

            for (var i in t) {
              t[i].setAttribute("data-drag-handle", this._uid);
            }
          }

          if (this.dragCancel) {
            var e = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragCancel));

            for (var n in e) {
              e[n].setAttribute("data-drag-cancel", this._uid);
            }
          }
        },
        beforeDestroy: function beforeDestroy() {
          document.documentElement.removeEventListener("mousemove", this.move), document.documentElement.removeEventListener("mouseup", this.up), document.documentElement.removeEventListener("mouseleave", this.up), document.documentElement.removeEventListener("mousedown", this.deselect), document.documentElement.removeEventListener("touchmove", this.move, !0), document.documentElement.removeEventListener("touchend touchcancel", this.up, !0), document.documentElement.removeEventListener("touchstart", this.up, !0);
        },
        methods: {
          deselect: function deselect() {
            this.preventActiveBehavior || (this.active = !1);
          },
          move: function move(t) {
            (this.stickDrag || this.bodyDrag) && (t.stopPropagation(), this.stickDrag && this.stickMove(t), this.bodyDrag && this.bodyMove(t));
          },
          up: function up(t) {
            this.stickDrag && this.stickUp(t), this.bodyDrag && this.bodyUp(t);
          },
          bodyDown: function bodyDown(t) {
            var i = t.target || t.srcElement;
            this.preventActiveBehavior || (this.active = !0), t.button && 0 !== t.button || (this.$emit("clicked", t), this.isDraggable && this.active && (this.dragHandle && i.getAttribute("data-drag-handle") !== this._uid.toString() || this.dragCancel && i.getAttribute("data-drag-cancel") === this._uid.toString() || (this.bodyDrag = !0, this.stickStartPos.mouseX = t.pageX || t.touches[0].pageX, this.stickStartPos.mouseY = t.pageY || t.touches[0].pageY, this.stickStartPos.left = this.left, this.stickStartPos.right = this.right, this.stickStartPos.top = this.top, this.stickStartPos.bottom = this.bottom, this.parentLimitation && (this.limits = this.calcDragLimitation()))));
          },
          calcDragLimitation: function calcDragLimitation() {
            var t = this.parentWidth,
                i = this.parentHeight;
            return {
              minLeft: 0,
              maxLeft: t - this.width,
              minRight: 0,
              maxRight: t - this.width,
              minTop: 0,
              maxTop: i - this.height,
              minBottom: 0,
              maxBottom: i - this.height
            };
          },
          bodyMove: function bodyMove(t) {
            var i = this.stickStartPos,
                e = {
              x: ("y" !== this.axis && "none" !== this.axis ? i.mouseX - (t.pageX || t.touches[0].pageX) : 0) / this.parentScaleX,
              y: ("x" !== this.axis && "none" !== this.axis ? i.mouseY - (t.pageY || t.touches[0].pageY) : 0) / this.parentScaleY
            };
            this.rawTop = i.top - e.y, this.rawBottom = i.bottom + e.y, this.rawLeft = i.left - e.x, this.rawRight = i.right + e.x, this.$emit("dragging", this.rect);
          },
          bodyUp: function bodyUp() {
            this.bodyDrag = !1, this.$emit("dragging", this.rect), this.$emit("dragstop", this.rect), this.stickStartPos = {
              mouseX: 0,
              mouseY: 0,
              x: 0,
              y: 0,
              w: 0,
              h: 0
            }, this.limits = {
              minLeft: null,
              maxLeft: null,
              minRight: null,
              maxRight: null,
              minTop: null,
              maxTop: null,
              minBottom: null,
              maxBottom: null
            };
          },
          stickDown: function stickDown(t, i) {
            if (this.isResizable && this.active) {
              switch (this.stickDrag = !0, this.stickStartPos.mouseX = i.pageX || i.touches[0].pageX, this.stickStartPos.mouseY = i.pageY || i.touches[0].pageY, this.stickStartPos.left = this.left, this.stickStartPos.right = this.right, this.stickStartPos.top = this.top, this.stickStartPos.bottom = this.bottom, this.currentStick = t.split(""), this.stickAxis = null, this.currentStick[0]) {
                case "b":
                case "t":
                  this.stickAxis = "y";
              }

              switch (this.currentStick[1]) {
                case "r":
                case "l":
                  this.stickAxis = "y" === this.stickAxis ? "xy" : "x";
              }

              this.limits = this.calcResizeLimitation();
            }
          },
          calcResizeLimitation: function calcResizeLimitation() {
            var t = this.minWidth,
                i = this.minHeight,
                e = this.aspectFactor,
                n = this.width,
                o = this.height,
                s = this.bottom,
                r = this.top,
                a = this.left,
                h = this.right,
                c = this.stickAxis,
                u = this.parentLimitation ? 0 : null;
            this.aspectRatio && (t / i > e ? i = t / e : t = e * i);
            var l = {
              minLeft: u,
              maxLeft: a + (n - t),
              minRight: u,
              maxRight: h + (n - t),
              minTop: u,
              maxTop: r + (o - i),
              minBottom: u,
              maxBottom: s + (o - i)
            };

            if (this.aspectRatio) {
              var m = {
                minLeft: a - Math.min(r, s) * e * 2,
                maxLeft: a + (o - i) / 2 * e * 2,
                minRight: h - Math.min(r, s) * e * 2,
                maxRight: h + (o - i) / 2 * e * 2,
                minTop: r - Math.min(a, h) / e * 2,
                maxTop: r + (n - t) / 2 / e * 2,
                minBottom: s - Math.min(a, h) / e * 2,
                maxBottom: s + (n - t) / 2 / e * 2
              };
              "x" === c ? l = {
                minLeft: Math.max(l.minLeft, m.minLeft),
                maxLeft: Math.min(l.maxLeft, m.maxLeft),
                minRight: Math.max(l.minRight, m.minRight),
                maxRight: Math.min(l.maxRight, m.maxRight)
              } : "y" === c && (l = {
                minTop: Math.max(l.minTop, m.minTop),
                maxTop: Math.min(l.maxTop, m.maxTop),
                minBottom: Math.max(l.minBottom, m.minBottom),
                maxBottom: Math.min(l.maxBottom, m.maxBottom)
              });
            }

            return l;
          },
          stickMove: function stickMove(t) {
            var i = this.stickStartPos,
                e = {
              x: (i.mouseX - (t.pageX || t.touches[0].pageX)) / this.parentScaleX,
              y: (i.mouseY - (t.pageY || t.touches[0].pageY)) / this.parentScaleY
            };

            switch (this.currentStick[0]) {
              case "b":
                this.rawBottom = i.bottom + e.y;
                break;

              case "t":
                this.rawTop = i.top - e.y;
            }

            switch (this.currentStick[1]) {
              case "r":
                this.rawRight = i.right + e.x;
                break;

              case "l":
                this.rawLeft = i.left - e.x;
            }

            this.$emit("resizing", this.rect);
          },
          stickUp: function stickUp() {
            this.stickDrag = !1, this.stickStartPos = {
              mouseX: 0,
              mouseY: 0,
              x: 0,
              y: 0,
              w: 0,
              h: 0
            }, this.limits = {
              minLeft: null,
              maxLeft: null,
              minRight: null,
              maxRight: null,
              minTop: null,
              maxTop: null,
              minBottom: null,
              maxBottom: null
            }, this.rawTop = this.top, this.rawBottom = this.bottom, this.rawLeft = this.left, this.rawRight = this.right, this.stickAxis = null, this.$emit("resizing", this.rect), this.$emit("resizestop", this.rect);
          },
          aspectRatioCorrection: function aspectRatioCorrection() {
            if (this.aspectRatio) {
              var t = this.bottom,
                  i = this.top,
                  e = this.left,
                  n = this.right,
                  o = this.width,
                  s = this.height,
                  r = this.aspectFactor,
                  a = this.currentStick;

              if (o / s > r) {
                var h = r * s;
                "l" === a[1] ? this.left = e + o - h : this.right = n + o - h;
              } else {
                var c = o / r;
                "t" === a[0] ? this.top = i + s - c : this.bottom = t + s - c;
              }
            }
          }
        },
        computed: {
          style: function style() {
            return {
              top: this.top + "px",
              left: this.left + "px",
              width: this.width + "px",
              height: this.height + "px",
              zIndex: this.zIndex
            };
          },
          vdrStick: function vdrStick() {
            var t = this;
            return function (i) {
              var e = {
                width: 8 / t.parentScaleX + "px",
                height: 8 / t.parentScaleY + "px"
              };
              return e[n.y[i[0]]] = 8 / t.parentScaleX / -2 + "px", e[n.x[i[1]]] = 8 / t.parentScaleX / -2 + "px", e;
            };
          },
          width: function width() {
            return this.parentWidth - this.left - this.right;
          },
          height: function height() {
            return this.parentHeight - this.top - this.bottom;
          },
          rect: function rect() {
            return {
              left: Math.round(this.left),
              top: Math.round(this.top),
              width: Math.round(this.width),
              height: Math.round(this.height)
            };
          }
        },
        watch: {
          rawLeft: function rawLeft(t) {
            var i = this.limits,
                e = this.stickAxis,
                n = this.aspectFactor,
                o = this.aspectRatio,
                s = this.left,
                r = this.bottom,
                a = this.top;

            if (null !== i.minLeft && t < i.minLeft ? t = i.minLeft : null !== i.maxLeft && i.maxLeft < t && (t = i.maxLeft), o && "x" === e) {
              var h = s - t;
              this.rawTop = a - h / n / 2, this.rawBottom = r - h / n / 2;
            }

            this.left = t;
          },
          rawRight: function rawRight(t) {
            var i = this.limits,
                e = this.stickAxis,
                n = this.aspectFactor,
                o = this.aspectRatio,
                s = this.right,
                r = this.bottom,
                a = this.top;

            if (null !== i.minRight && t < i.minRight ? t = i.minRight : null !== i.maxRight && i.maxRight < t && (t = i.maxRight), o && "x" === e) {
              var h = s - t;
              this.rawTop = a - h / n / 2, this.rawBottom = r - h / n / 2;
            }

            this.right = t;
          },
          rawTop: function rawTop(t) {
            var i = this.limits,
                e = this.stickAxis,
                n = this.aspectFactor,
                o = this.aspectRatio,
                s = this.right,
                r = this.left,
                a = this.top;

            if (null !== i.minTop && t < i.minTop ? t = i.minTop : null !== i.maxTop && i.maxTop < t && (t = i.maxTop), o && "y" === e) {
              var h = a - t;
              this.rawLeft = r - h * n / 2, this.rawRight = s - h * n / 2;
            }

            this.top = t;
          },
          rawBottom: function rawBottom(t) {
            var i = this.limits,
                e = this.stickAxis,
                n = this.aspectFactor,
                o = this.aspectRatio,
                s = this.right,
                r = this.left,
                a = this.bottom;

            if (null !== i.minBottom && t < i.minBottom ? t = i.minBottom : null !== i.maxBottom && i.maxBottom < t && (t = i.maxBottom), o && "y" === e) {
              var h = a - t;
              this.rawLeft = r - h * n / 2, this.rawRight = s - h * n / 2;
            }

            this.bottom = t;
          },
          width: function width() {
            this.aspectRatioCorrection();
          },
          height: function height() {
            this.aspectRatioCorrection();
          },
          active: function active(t) {
            t ? this.$emit("activated") : this.$emit("deactivated");
          },
          isActive: function isActive(t) {
            this.active = t;
          },
          z: function z(t) {
            (t >= 0 || "auto" === t) && (this.zIndex = t);
          },
          aspectRatio: function aspectRatio(t) {
            t && (this.aspectFactor = this.width / this.height);
          },
          minw: function minw(t) {
            t > 0 && t <= this.width && (this.minWidth = t);
          },
          minh: function minh(t) {
            t > 0 && t <= this.height && (this.minHeight = t);
          },
          x: function x() {
            if (!this.stickDrag && !this.bodyDrag) {
              this.parentLimitation && (this.limits = this.calcDragLimitation());
              var t = this.x - this.left;
              this.rawLeft = this.x, this.rawRight = this.right - t;
            }
          },
          y: function y() {
            if (!this.stickDrag && !this.bodyDrag) {
              this.parentLimitation && (this.limits = this.calcDragLimitation());
              var t = this.y - this.top;
              this.rawTop = this.y, this.rawBottom = this.bottom - t;
            }
          },
          w: function w() {
            if (!this.stickDrag && !this.bodyDrag) {
              this.currentStick = ["m", "r"], this.stickAxis = "x", this.parentLimitation && (this.limits = this.calcResizeLimitation());
              var t = this.width - this.w;
              this.rawRight = this.right + t;
            }
          },
          h: function h() {
            if (!this.stickDrag && !this.bodyDrag) {
              this.currentStick = ["b", "m"], this.stickAxis = "y", this.parentLimitation && (this.limits = this.calcResizeLimitation());
              var t = this.height - this.h;
              this.rawBottom = this.bottom + t;
            }
          },
          parentW: function parentW(t) {
            this.right = t - this.width - this.left, this.parentWidth = t;
          },
          parentH: function parentH(t) {
            this.bottom = t - this.height - this.top, this.parentHeight = t;
          }
        }
      };
    },
    15: function _(t, i) {
      t.exports = function (t) {
        var i = "undefined" != typeof window && window.location;
        if (!i) throw new Error("fixUrls requires window.location");
        if (!t || "string" != typeof t) return t;
        var e = i.protocol + "//" + i.host,
            n = e + i.pathname.replace(/\/[^\/]*$/, "/");
        return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, i) {
          var o = i.trim().replace(/^"(.*)"$/, function (t, i) {
            return i;
          }).replace(/^'(.*)'$/, function (t, i) {
            return i;
          });
          if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o)) return t;
          var s;
          return s = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? e + o : n + o.replace(/^\.\//, ""), "url(" + JSON.stringify(s) + ")";
        });
      };
    },
    16: function _(t, i, e) {
      i = t.exports = e(6)(!1), i.push([t.i, '\n.vdr,.vdr.active:before{position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.vdr.active:before{content:"";width:100%;height:100%;top:0;left:0;outline:1px dashed #d6d6d6\n}\n.vdr-stick{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;font-size:1px;background:#fff;border:1px solid #6c6c6c;-webkit-box-shadow:0 0 2px #bbb;box-shadow:0 0 2px #bbb\n}\n.inactive .vdr-stick{display:none\n}\n.vdr-stick-br,.vdr-stick-tl{cursor:nwse-resize\n}\n.vdr-stick-bm,.vdr-stick-tm{left:50%;cursor:ns-resize\n}\n.vdr-stick-bl,.vdr-stick-tr{cursor:nesw-resize\n}\n.vdr-stick-ml,.vdr-stick-mr{top:50%;cursor:ew-resize\n}\n.vdr-stick.not-resizable{display:none\n}', ""]);
    },
    17: function _(t, i, e) {
      "use strict";

      var n = e(0),
          o = e.n(n);
      o.a;
    },
    18: function _(t, i, e) {
      "use strict";

      e.r(i);
      var n = e(4),
          o = e(2);

      for (var s in o) {
        "default" !== s && function (t) {
          e.d(i, t, function () {
            return o[t];
          });
        }(s);
      }

      var r = (e(17), e(3)),
          a = Object(r.a)(o["default"], n.a, n.b, !1, null, null, null);
      a.options.__file = "src/components/vue-drag-resize.vue", i["default"] = a.exports;
    },
    2: function _(t, i, e) {
      "use strict";

      e.r(i);
      var n = e(1),
          o = e.n(n);

      for (var s in n) {
        "default" !== s && function (t) {
          e.d(i, t, function () {
            return n[t];
          });
        }(s);
      }

      i["default"] = o.a;
    },
    3: function _(t, i, e) {
      "use strict";

      function n(t, i, e, n, o, s, r, a) {
        var h = "function" == typeof t ? t.options : t;
        i && (h.render = i, h.staticRenderFns = e, h._compiled = !0), n && (h.functional = !0), s && (h._scopeId = "data-v-" + s);
        var c;
        if (r ? (c = function c(t) {
          t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(r);
        }, h._ssrRegister = c) : o && (c = a ? function () {
          o.call(this, this.$root.$options.shadowRoot);
        } : o), c) if (h.functional) {
          h._injectStyles = c;
          var u = h.render;

          h.render = function (t, i) {
            return c.call(i), u(t, i);
          };
        } else {
          var l = h.beforeCreate;
          h.beforeCreate = l ? [].concat(l, c) : [c];
        }
        return {
          exports: t,
          options: h
        };
      }

      e.d(i, "a", function () {
        return n;
      });
    },
    4: function _(t, i, e) {
      "use strict";

      var n = function n() {
        var t = this,
            i = t.$createElement,
            e = t._self._c || i;
        return e("div", {
          staticClass: "vdr",
          "class": t.active || t.isActive ? "active" : "inactive",
          style: t.style,
          on: {
            mousedown: function mousedown(i) {
              i.stopPropagation(), i.preventDefault(), t.bodyDown(i);
            },
            touchstart: function touchstart(i) {
              i.stopPropagation(), i.preventDefault(), t.bodyDown(i);
            }
          }
        }, [t._t("default"), t._v(" "), t._l(t.sticks, function (i) {
          return e("div", {
            staticClass: "vdr-stick",
            "class": ["vdr-stick-" + i, t.isResizable ? "" : "not-resizable"],
            style: t.vdrStick(i),
            on: {
              mousedown: function mousedown(e) {
                e.stopPropagation(), e.preventDefault(), t.stickDown(i, e);
              },
              touchstart: function touchstart(e) {
                e.stopPropagation(), e.preventDefault(), t.stickDown(i, e);
              }
            }
          });
        })], 2);
      },
          o = [];

      n._withStripped = !0;
      e.d(i, "a", function () {
        return n;
      }), e.d(i, "b", function () {
        return o;
      });
    },
    44: function _(t, i, e) {
      "use strict";

      function n(t) {
        return t && t.__esModule ? t : {
          "default": t
        };
      }

      Object.defineProperty(i, "__esModule", {
        value: !0
      });
      var o = e(18);
      Object.defineProperty(i, "default", {
        enumerable: !0,
        get: function get() {
          return n(o)["default"];
        }
      });
    },
    5: function _(t, i, e) {
      function n(t, i) {
        for (var e = 0; e < t.length; e++) {
          var n = t[e],
              o = p[n.id];

          if (o) {
            o.refs++;

            for (var s = 0; s < o.parts.length; s++) {
              o.parts[s](n.parts[s]);
            }

            for (; s < n.parts.length; s++) {
              o.parts.push(u(n.parts[s], i));
            }
          } else {
            for (var r = [], s = 0; s < n.parts.length; s++) {
              r.push(u(n.parts[s], i));
            }

            p[n.id] = {
              id: n.id,
              refs: 1,
              parts: r
            };
          }
        }
      }

      function o(t, i) {
        for (var e = [], n = {}, o = 0; o < t.length; o++) {
          var s = t[o],
              r = i.base ? s[0] + i.base : s[0],
              a = s[1],
              h = s[2],
              c = s[3],
              u = {
            css: a,
            media: h,
            sourceMap: c
          };
          n[r] ? n[r].parts.push(u) : e.push(n[r] = {
            id: r,
            parts: [u]
          });
        }

        return e;
      }

      function s(t, i) {
        var e = v(t.insertInto);
        if (!e) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
        var n = x[x.length - 1];
        if ("top" === t.insertAt) n ? n.nextSibling ? e.insertBefore(i, n.nextSibling) : e.appendChild(i) : e.insertBefore(i, e.firstChild), x.push(i);else {
          if ("bottom" !== t.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
          e.appendChild(i);
        }
      }

      function r(t) {
        if (null === t.parentNode) return !1;
        t.parentNode.removeChild(t);
        var i = x.indexOf(t);
        i >= 0 && x.splice(i, 1);
      }

      function a(t) {
        var i = document.createElement("style");
        return t.attrs.type = "text/css", c(i, t.attrs), s(t, i), i;
      }

      function h(t) {
        var i = document.createElement("link");
        return t.attrs.type = "text/css", t.attrs.rel = "stylesheet", c(i, t.attrs), s(t, i), i;
      }

      function c(t, i) {
        Object.keys(i).forEach(function (e) {
          t.setAttribute(e, i[e]);
        });
      }

      function u(t, i) {
        var e, n, o, s;

        if (i.transform && t.css) {
          if (!(s = i.transform(t.css))) return function () {};
          t.css = s;
        }

        if (i.singleton) {
          var c = b++;
          e = g || (g = a(i)), n = l.bind(null, e, c, !1), o = l.bind(null, e, c, !0);
        } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (e = h(i), n = f.bind(null, e, i), o = function o() {
          r(e), e.href && URL.revokeObjectURL(e.href);
        }) : (e = a(i), n = m.bind(null, e), o = function o() {
          r(e);
        });

        return n(t), function (i) {
          if (i) {
            if (i.css === t.css && i.media === t.media && i.sourceMap === t.sourceMap) return;
            n(t = i);
          } else o();
        };
      }

      function l(t, i, e, n) {
        var o = e ? "" : n.css;
        if (t.styleSheet) t.styleSheet.cssText = w(i, o);else {
          var s = document.createTextNode(o),
              r = t.childNodes;
          r[i] && t.removeChild(r[i]), r.length ? t.insertBefore(s, r[i]) : t.appendChild(s);
        }
      }

      function m(t, i) {
        var e = i.css,
            n = i.media;
        if (n && t.setAttribute("media", n), t.styleSheet) t.styleSheet.cssText = e;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(e));
        }
      }

      function f(t, i, e) {
        var n = e.css,
            o = e.sourceMap,
            s = void 0 === i.convertToAbsoluteUrls && o;
        (i.convertToAbsoluteUrls || s) && (n = y(n)), o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var r = new Blob([n], {
          type: "text/css"
        }),
            a = t.href;
        t.href = URL.createObjectURL(r), a && URL.revokeObjectURL(a);
      }

      var p = {},
          d = function (t) {
        var i;
        return function () {
          return void 0 === i && (i = t.apply(this, arguments)), i;
        };
      }(function () {
        return window && document && document.all && !window.atob;
      }),
          v = function (t) {
        var i = {};
        return function (e) {
          return void 0 === i[e] && (i[e] = t.call(this, e)), i[e];
        };
      }(function (t) {
        return document.querySelector(t);
      }),
          g = null,
          b = 0,
          x = [],
          y = e(15);

      t.exports = function (t, i) {
        if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
        i = i || {}, i.attrs = "object" == _typeof(i.attrs) ? i.attrs : {}, i.singleton || (i.singleton = d()), i.insertInto || (i.insertInto = "head"), i.insertAt || (i.insertAt = "bottom");
        var e = o(t, i);
        return n(e, i), function (t) {
          for (var s = [], r = 0; r < e.length; r++) {
            var a = e[r],
                h = p[a.id];
            h.refs--, s.push(h);
          }

          if (t) {
            n(o(t, i), i);
          }

          for (var r = 0; r < s.length; r++) {
            var h = s[r];

            if (0 === h.refs) {
              for (var c = 0; c < h.parts.length; c++) {
                h.parts[c]();
              }

              delete p[h.id];
            }
          }
        };
      };

      var w = function () {
        var t = [];
        return function (i, e) {
          return t[i] = e, t.filter(Boolean).join("\n");
        };
      }();
    },
    6: function _(t, i) {
      function e(t, i) {
        var e = t[1] || "",
            o = t[3];
        if (!o) return e;

        if (i && "function" == typeof btoa) {
          var s = n(o);
          return [e].concat(o.sources.map(function (t) {
            return "/*# sourceURL=" + o.sourceRoot + t + " */";
          })).concat([s]).join("\n");
        }

        return [e].join("\n");
      }

      function n(t) {
        return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
      }

      t.exports = function (t) {
        var i = [];
        return i.toString = function () {
          return this.map(function (i) {
            var n = e(i, t);
            return i[2] ? "@media " + i[2] + "{" + n + "}" : n;
          }).join("");
        }, i.i = function (t, e) {
          "string" == typeof t && (t = [[null, t, ""]]);

          for (var n = {}, o = 0; o < this.length; o++) {
            var s = this[o][0];
            "number" == typeof s && (n[s] = !0);
          }

          for (o = 0; o < t.length; o++) {
            var r = t[o];
            "number" == typeof r[0] && n[r[0]] || (e && !r[2] ? r[2] = e : e && (r[2] = "(" + r[2] + ") and (" + e + ")"), i.push(r));
          }
        }, i;
      };
    }
  });
});